import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { SmartLockProvider } from '../../providers/smart-lock/smart-lock';
import { ToastProvider, ToastType } from '../../providers/toast/toast';
import { SmartLockLogPage } from '../smart-lock-log/smart-lock-log';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-smart-lock',
  templateUrl: 'smart-lock.html',
})
export class SmartLockPage {
  smartLocks =[];
  timerId :any;
  timeOut :any;
  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private smartLockProvider: SmartLockProvider, 
    private toast: ToastProvider,
    private translate: TranslateService,
    private app: App
    ) {
    this.getSmartLocksData();
  }

  getSmartLocksData(){
    this.smartLockProvider.getSmartLocks().then((val:any) =>{
      console.log("get smart lock call"+val);
      if(val.status == 'success'){
        this.smartLocks = val.data;
      }
    }).catch(error=>{

    })
  }

  unlockSmartLock(smartLock, index){
    clearTimeout(this.timeOut);
    clearInterval(this.timerId); 
    this.smartLockProvider.unlockSmartLock(smartLock).then((val :any) =>{
      console.log("unloackk call >>>"+val.data);
      if(val.status+"" == 'success'){
        this.toast.presentToast("door unlock request is submitted");
        this.timerId = setInterval(() => {
          this.requestStatus(val.data, index, false);
        }, 1500);
        this.timeOut=setTimeout(() => { 
          clearInterval(this.timerId); 
          this.requestStatus(val.data, index, true); 
        }, 10000);
       
      }
    }).catch(error=>{
    })
  }


  requestStatus(data, index, lastCall){
    this.smartLockProvider.requestStatus(data).then((val:any) =>{
      console.log("requeststatus>>"+val);
      if(val.status == 'success' && val.data.status == 2){
        clearTimeout(this.timeOut);
        clearInterval(this.timerId); 
        this.toast.presentToast("door is unloked");
        this.smartLocks[index].action=true;
        setTimeout(() => {
          this.getSmartLocksData();
        },4000);
      }else{
        if(lastCall){
          this.toast.presentToast("something went wrong");
          this.getSmartLocksData();
        }
      }
    });
  }

  setVehicleAccess(data){
    if(data && data.enable && data.enable==true){
      data.enable = 1;
    }else if(data && data.enable== false){
      data.enable = 0 ;
    }
    this.smartLockProvider.updateVehicleAccessStatus(data).then((val:any)=>{
      if(val.status == 'success'){
        setTimeout(() => {
          this.toast.presentToast("vehicle access log changed");
          this.getSmartLocksData();
        },6000);
      }
    });
  }

  smartLockLog(lockData: any){
    this.smartLockProvider.requestStatus(lockData).then((val:any) =>{
      if(val.status == 'success'){
        console.log(val.data);
        this.app.getRootNav().push(SmartLockLogPage, {
          parent: this,
          data: null
        })
      }
    }).catch(error => {
      console.log(error);
    });
  }

  // doRefresh(refresher) {
  //   clearTimeout(this.timeOut);
  //   clearInterval(this.timerId); 
  //   this.getSmartLocksData()
  //   refresher.complete();
  // }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SmartLockPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/smart-lock/smart-lock.ts